/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
} from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable, from, switchMap } from 'rxjs';

import { EnvironmentInterface } from '../models/environment.interface';
import { ENVIRONMENT } from '../models/environment.token';
import { TokenService } from '../services/token-service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  private environment = inject<EnvironmentInterface>(ENVIRONMENT);
  private tokenService = inject(TokenService);

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    if (request.url.indexOf(this.environment.appApiUrl) >= 0) {
      return from(this.tokenService.getToken()).pipe(
        switchMap((token: string | null) => {
          if (token) {
            request = request.clone({
              setHeaders: {
                Authorization: token,
              },
            });
          }
          return next.handle(request);
        }),
      );
    }

    return next.handle(request);
  }
}
